import { render } from "./SubMenu.vue?vue&type=template&id=fcc42162"
import script from "./SubMenu.vue?vue&type=script&lang=js"
export * from "./SubMenu.vue?vue&type=script&lang=js"
script.render = render

export default script